import script from "./TaskCardList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCardList.vue?vue&type=script&setup=true&lang=js"

import "./TaskCardList.vue?vue&type=style&index=0&id=d011c20e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d011c20e"]])

export default __exports__